import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { connect } from 'react-redux';
import { Text } from '@beef/ui-kit';
import { Flex } from '@fttb/common';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { devideUnitPrice } from "./helper";
import { getDevicePrice, getDeviceSelection, getDeviderSignPriceUnit, getPaymentPeriodText } from "../../../../store/blocks/devices/selectors";
import { DEVICE_PAYMENT_TYPE } from "../../../constants";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _DevicePrice = function _DevicePrice(_ref) {
  var deviderSignPriceUnit = _ref.deviderSignPriceUnit,
    paymentPeriodText = _ref.paymentPeriodText,
    price = _ref.price,
    selection = _ref.selection;
  var _devideUnitPrice = devideUnitPrice(price.unit, deviderSignPriceUnit),
    _devideUnitPrice2 = _slicedToArray(_devideUnitPrice, 2),
    unit = _devideUnitPrice2[0],
    currency = _devideUnitPrice2[1];
  if (!price.value || selection === DEVICE_PAYMENT_TYPE.preEnabled) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('price'),
    "data-t-id": "components-DevicePrice"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size6-m"
  }, paymentPeriodText), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Text, {
    className: cx('price__value'),
    "data-t-id": "components-DevicePrice"
  }, price.value, " ", currency), /*#__PURE__*/React.createElement(Text, {
    className: "pad-t-m",
    color: "grey60",
    size: "size5-m"
  }, unit)));
};
_DevicePrice.propTypes = process.env.NODE_ENV !== "production" ? {
  deviderSignPriceUnit: PropTypes.string,
  paymentPeriodText: PropTypes.string,
  price: PropTypes.shape({
    unit: PropTypes.string,
    value: PropTypes.number
  }),
  selection: PropTypes.string
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    deviderSignPriceUnit: getDeviderSignPriceUnit(state),
    paymentPeriodText: getPaymentPeriodText(state),
    price: getDevicePrice(state),
    selection: getDeviceSelection(state)
  };
};
export var DevicePrice = connect(mapStateToProps)(_DevicePrice);